<template>
  <div class="kt-portlet">
    <div class="kt-portlet__body">
      <div class="kt-mycart">
        <div class="kt-mycart__body kt-scroll" data-scroll="true" data-height="245" data-mobile-height="200">
          <div class="kt-mycart__item">
            <div class="kt-mycart__container">
              <div class="kt-mycart__info">
                <h5 class="kt-mycart__title">Total Images</h5>
              </div>
              <div class="kt-mycart__price"><strong>{{ images.length }}</strong></div>
            </div>
          </div>

          <div v-if="!isQuotationRequest && getImageComplexityPrice()" class="kt-mycart__item">
            <div class="kt-mycart__container">
              <div class="kt-mycart__info">
                <h5 class="kt-mycart__title">Image Complexity</h5>
                <span class="kt-mycart__desc">
                  <template v-for="(info, index) in complexityInfo">
                    {{ info.title }}: {{ info.total }}
                      <template v-if="index != complexityInfo.length - 1">,</template>
                  </template>
                </span>
              </div>
              <div class="kt-mycart__price">${{ Number(getImageComplexityPrice()).toFixed(2) }}</div>
            </div>
          </div>

          <div v-if="orderServiceComponents.length" class="kt-mycart__item">
            <div class="kt-mycart__container" style="padding-bottom: 0 !important;">
              <div class="kt-mycart__info">
                <h5 class="kt-mycart__title">Add-Ons</h5>
                <span class="kt-mycart__desc">
                  <div v-for="component in orderServiceComponents" :key="component.id">
                    <p>
                      <i class="fa fa-check-circle"></i>
                      <span class="d-inline mx-1">{{ getOrderComponentName(component) }}:</span>
                      <span
                        class="d-inline mr-1"
                        style="font-weight: 600;"
                        v-for="(choice, index) in getOrderComponentChoices(component)" :key="index"
                      >
                        {{ choice.title }}
                        <template v-if="index != getOrderComponentChoices(component).length - 1">,</template>
                      </span>
                    </p>
                  </div>
                </span>
              </div>
              <div v-if="!isQuotationRequest" class="kt-mycart__price">${{ Number(getOrderServiceComponentsPrice()).toFixed(2) }}</div>
            </div>
            <div class="kt-mycart__container" style="padding: 0 !important;">
              <div class="kt-mycart__info">
                <span class="kt-mycart__desc">
                  <div v-for="(service, key, index) in orderAddOns" :key="index">
                    <div v-if="key === 'retouch'" style="margin-bottom: 5px;">
                      <p><i class="fa fa-check-circle"></i> {{ key | capitalize }}</p>
                    </div>
                    <div v-if="key === 'adjustment'" style="margin-bottom: 5px;">
                      <p><i class="fa fa-check-circle"></i> {{ key | capitalize }}</p>
                    </div>
                    <div v-if="key === 'websizes'" style="margin-bottom: 5px;">
                      <p><i class="fa fa-check-circle"></i> {{ key | capitalize }}</p>
                      <!--<div v-for="(item, index) in service" :key="index">
                        <small style="margin-right: 20px;">W: {{ item.width }}</small>
                        <small>H: {{ item.width }}</small>
                        <br>
                      </div>-->
                    </div>
                    <div v-if="key === 'margin'" style="margin-bottom: 5px;">
                      <p><i class="fa fa-check-circle"></i> {{ key | capitalize }}</p>
                      <!--<small style="margin-right: 20px;">Top: {{ service.marginProperty.top}}</small>
                      <small>Bottom: {{ service.marginProperty.bottom }}</small>
                      <br>
                      <small style="margin-right: 20px;">Left: {{ service.marginProperty.left}}</small>&nbsp;
                      <small>Right: {{ service.marginProperty.right }}</small>-->
                    </div>
                  </div>
                </span>
              </div>
              <div v-if="!isQuotationRequest && hasAddons()" class="kt-mycart__price">${{ Number(getAddOnsPrice()).toFixed(2) }}</div>
            </div>
          </div>

          <div class="kt-mycart__item" v-if="orderDeliveryTimeId">
            <div class="kt-mycart__container">
              <div class="kt-mycart__info">
                <a href="#" class="kt-mycart__title">Delivery Time</a>
                <span class="kt-mycart__desc">
                  <template>{{ getDeliveryTimeName() }}</template>
                </span>
              </div>
              <div v-if="!isQuotationRequest" class="kt-mycart__price">${{ Number(getDeliveryTimeExtraPrice()).toFixed(2) }}</div>
            </div>
          </div>
        </div>

        <div class="kt-mycart__footer" style="padding: 0 !important; line-height: 25px;">
          <template v-if="orderDeliveryTimeId">
            <template v-if="!isQuotationRequest">
              <div class="kt-mycart__item">
                <div class="kt-mycart__container">
                  <div class="kt-mycart__info w-100" v-if="!orderCoupon">
                    <h5 class="kt-mycart__title">Coupon</h5>
                    <div class="input-group mb-4">
                      <input type="text" class="form-control" v-model="coupon" placeholder="Discount Coupon Code" />
                      <div class="input-group-append">
                        <button class="btn btn-success" type="button" @click="applyCoupon">Apply</button>
                      </div>
                    </div>
                    <p class="text-danger" v-if="couponErrorMessage">{{ couponErrorMessage }}</p>
                  </div>
                </div>
              </div>
            </template>

            <div v-if="!isQuotationRequest" class="kt-mycart__section">
              <div class="kt-mycart__subtitel">
                <template v-if="orderCoupon">
                  <span v-if="!isQuotationRequest">Sub Total</span>
                  <span v-if="!isQuotationRequest">Coupon Applied</span>
                </template>
              </div>
              <div class="kt-mycart__prices">
                <template v-if="orderCoupon">
                  <span v-if="!isQuotationRequest">${{ Number(getDeliveryTimePrice()).toFixed(2) }}</span>
                  <span v-if="!isQuotationRequest">${{ orderCoupon ? Number(getDiscountPrice()).toFixed(2) : '0.00' }}</span>
                </template>
              </div>
            </div>

            <div v-if="!isQuotationRequest" class="kt-mycart__section mt-3">
              <div class="kt-mycart__subtitel mt-3">
                <span>Total</span>
              </div>
              <div class="kt-mycart__prices mt-3">
                <span class="kt-font-brand">
                  ${{ Number(getTotalPrice()).toFixed(2) }}
                </span>
              </div>
            </div>
          </template>

          <div class="kt-mycart__button kt-align-center d-flex d-flex flex-wrap mt-5">
            <slot name="footerBtns"></slot>

            <template v-if="orderDeliveryTimeId">
              <template v-if="isQuotationRequest">
                <button type="button" class="btn btn-primary m-1" :disabled="isDisabled" @click="requestQuotation">
                  <div class="d-flex align-items-center">
                    <div><i class="fa fa-check-circle"></i> Request Quote</div>
                    <div v-if="isDisabled" class="spinner-border spinner-border-sm ml-2" role="status">
                      <span class="sr-only">Loading...</span>
                    </div>
                  </div>
                </button>
              </template>

              <template v-if="!isQuotationRequest">
                <button type="button" class="btn btn-default m-1" :disabled="isDisabled || saving" @click="saveAsDraft">
                  <div class="d-flex align-items-center">
                    <div><i class="fa fa-check-circle"></i> Save as Draft</div>
                    <div v-if="saving" class="spinner-border spinner-border-sm ml-2" role="status">
                      <span class="sr-only">Loading...</span>
                    </div>
                  </div>
                </button>

                <button type="button" class="btn btn-primary m-1" v-if="site.payment_gateway === 'stripe' && ! user.is_postpaid" @click="placeStripeOrder" :disabled="isDisabled || saving">
                  <div class="d-flex align-items-center">
                    <div><i class="fa fa-credit-card"></i> Submit &amp; Pay</div>
                    <div v-if="isDisabled" class="spinner-border spinner-border-sm ml-2" role="status">
                      <span class="sr-only">Loading...</span>
                    </div>
                  </div>
                </button>

                  <button type="button" class="btn btn-primary m-1" v-if="site.payment_gateway === 'stripe' && user.is_postpaid" @click="placePostpaidOrder" :disabled="isDisabled || saving">
                  <div class="d-flex align-items-center">
                    <div><i class="fa fa-credit-card"></i> Submit</div>
                          <div v-if="isDisabled" class="spinner-border spinner-border-sm ml-2" role="status">
                      <span class="sr-only">Loading...</span>
                    </div>
                  </div>
                </button>


                  <button type="button" class="btn btn-primary m-1" v-if="site.payment_gateway === '2checkout'" @click="placeTwoCheckoutOrder" :disabled="isDisabled">
                  <div class="d-flex align-items-center">
                    <div>Pay With 2Checkout Card</div>
                    <div v-if="isDisabled" class="spinner-border spinner-border-sm ml-2" role="status">
                      <span class="sr-only">Loading...</span>
                    </div>
                  </div>
                </button>
                <button type="button" class="btn btn-info m-1" v-if="site.payment_gateway === '2checkout'" @click="placeTwoCheckoutOrderPaypal">
                  <div class="d-flex align-items-center">
                    <div>Pay With 2Checkout Paypal</div>
                    <div class="spinner-border spinner-border-sm ml-2" role="status">
                      <span class="sr-only">Loading...</span>
                    </div>
                  </div>
                </button>

               
              </template>
            </template>
          </div>

        </div>
      </div>
    </div>
    <stripe-payment-modal v-if="site.payment_gateway === 'stripe'" @closed="isDisabled=false"></stripe-payment-modal>
    <two-checkout-payment-modal v-if="site.payment_gateway === '2checkout'"></two-checkout-payment-modal>
  </div>
</template>

<script>
import StripePaymentModal from '@/components/StripePaymentModal.vue';
import TwoCheckoutPaymentModal from '@/components/TwoCheckoutPaymentModal.vue';
import orderMixin from '@/mixins/orderMixin';
import { mapActions, mapGetters } from 'vuex';
export default {
  components: {
    StripePaymentModal,
    TwoCheckoutPaymentModal
  },
  mixins: [orderMixin],
  data() {
    return {
      coupon: '',
      couponErrorMessage: '',
      orderTotal: null,
      orderId: null,
      isDisabled: false,
      saving: false,
    };
  },
  computed: {
    ...mapGetters({
      site: 'site/site',
      name: 'order/name',
      instruction: 'order/instruction',
      images: 'order/images',
      orderCoupon: 'order/coupon',
      orderDeliveryTimeId: 'order/deliveryTimeId',
      order: 'order/order',
      orderID: 'order/orderId',
      isQuotationRequest: "order/isQuotationRequest",
      user: 'auth/user'
    }),
  },
  filters: {
    capitalize: function (value) {
      if (!value) return ''
      value = value.toString()
      return value.charAt(0).toUpperCase() + value.slice(1)
    }
  },
  methods: {
    ...mapActions({
      orderApplyCoupon: 'order/applyCoupon',
      orderSetPrice: 'order/setPrice',
      storeOrder: 'order/storeOrder',
      updateOrder: 'order/updateOrder',
      createStripePaymentIntent: 'order/createStripePaymentIntent',
      setClientSecret: 'order/setClientSecret',
      setOrderId: 'order/setOrderId',
      setIsCreatingOrder: "order/setIsCreatingOrder",
      setDraft: "order/setDraft",
      saveOrderInDraft: "order/saveOrderInDraft",
    }),
    applyCoupon() {
      if (this.coupon === '') {
        return;
      }

      this.couponErrorMessage = '';

      this.orderApplyCoupon({
        coupon: this.coupon,
      }).catch((error) => {
        this.coupon = '';
        this.couponErrorMessage = error.response.data;
      });
    },

    saveOrder() {
      return this.orderID
        ? this.updateOrder({
            orderID: this.orderID,
            order: this.order,
          })
        : this.storeOrder({ order: this.order });
    },

    requestQuotation() {
      this.isDisabled = true;

      this.saveOrder()
        .then(() => {
          this.setIsCreatingOrder(false);
          this.$swal({
          icon: 'success',
          title: 'Success...',
          text: 'Question request sent successfully!',
          });
          this.$router.push({
          name: 'order',
          });
        })
        .catch(() => {
          this.$swal({
          icon: 'error',
          title: 'Oops...',
          text: 'Something went wrong!',
          });
        });
    },
    saveAsDraft() {
      this.saving = true;
      this.setDraft(true);

      // const res =  this.orderID ? this.saveOrderInDraft(this.orderID) : this.storeOrder({order: this.order})
      this.saveOrder()
        .then((response) => {
          this.setIsCreatingOrder(false);
          this.$swal({
          icon: 'success',
          title: 'Success...',
          text: 'Order saved as draft successfully!',
          });
          this.$router.push({
          name: 'order-details',
          params:{'id': response.data.id}
          });
        })
        .catch(() => {
          this.saving = false;
          this.$swal({
          icon: 'error',
          title: 'Oops...',
          text: 'Something went wrong!',
          });
        });
    },

    async placePostpaidOrder() {
      this.isDisabled = true;

      this.orderSetPrice({
        price: Number(this.getTotalPrice).toFixed(2),
      });

      this.saveOrder()
        .then(() => {
          this.setIsCreatingOrder(false);
          this.$swal({
          icon: 'success',
          title: 'Success...',
          text: 'Order Placed Successfully!',
          });
          this.$router.push({
          name: 'order',
          });
        })
        .catch(() => {
          this.$swal({
          icon: 'error',
          title: 'Oops...',
          text: 'Something went wrong!',
          });
        });
    },

    async placeStripeOrder() {
      this.isDisabled = true;

      this.orderSetPrice({
        price: Number(this.getTotalPrice).toFixed(2),
      });

      try {
        // if (!this.orderID) {
        //   const response = await this.storeOrder({ order: this.order });
        //   this.setOrderId({ orderId: response.data.id });
        // }
        const response = await this.saveOrder();
        this.setOrderId({ orderId: response.data.id });

        this.createStripePaymentIntent({
          order_id: this.orderID
        })
          .then((response) => {
            this.setClientSecret({
              clientSecret: response.data.client_secret,
            });

            this.$modal.show("stripe-payment-modal");
          })
          .catch(() => {
            this.isDisabled = false;
            this.$swal({
              icon: "error",
              title: "Oops...",
              text: "Something went wrong!",
            });
            // this.setIsCreatingOrder(false);
            // this.$router.push({
            //   name: "order-details",
            //   params: { id: this.orderID },
            // });
          });
      } catch (error) {
        this.isDisabled = false;
        this.$swal({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
        });
      }
    },
    placeTwoCheckoutOrderPaypal() {
      //
    },
    placeTwoCheckoutOrder() {
      this.isDisabled = true;

      this.orderSetPrice({
        price: Number(this.getTotalPrice).toFixed(2),
      });

      this.saveOrder()
        .then((response) => {
          this.setOrderId({
            orderId: response.data.id
          });
          this.$modal.show('two-checkout-payment-modal');
        })
        .catch(() => {
          this.isDisabled = false
          this.$swal({
            icon: 'error',
            title: 'Oops...',
            text: 'Something went wrong!',
          });
        });
    },
  },
};
</script>

<style scoped>
.kt-mycart__container {
  padding: 1.5rem 0 !important;
}
.kt-mycart__price {
  font-size: 16px !important;
  color: #5d78ff;
  font-weight: 500;
}

.truncate {
  white-space: nowrap;
  overflow: hidden;
  width: 200px;
  display: inline-block !important;
  text-overflow: ellipsis;
  vertical-align: middle;
}
</style>
